module.exports = __webpack_public_path__ + "static/media/weixin_qrcode.01d46519.jpg";